import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { StatoVideoperizia } from 'src/app/models/stato-videoperizia';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditStatoVideoperiziaComponent extends BaseEditForm implements OnInit {

  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditStatoVideoperiziaComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: StatoVideoperizia,) {
    super();
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.data?.nome, Validators.required],
    });
  }

}

